import React from "react"
import { FaSearch } from "react-icons/fa"
import { Button, FormInput, FormLabel } from "../../../components/ui"
import { getInitialDate, toISODateInput } from "../../../helper/formatDate"

export default function ExpiredProductInvoiceFilter({ onSubmitFilter }) {
  const [expiredDate, setExpiredDate] = React.useState("")

  const handleSubmit = (evt) => {
    evt.preventDefault()
    onSubmitFilter(expiredDate)
  }

  return (
    <div className="mb-3 py-2">
      <div className="mb-3 flex justify-between items-end">
        <form className="flex items-end space-x-3" onSubmit={handleSubmit}>
          <div className="relative" style={{ width: "12.5rem" }}>
            <FormLabel htmlFor="input-expired-date">Tanggal Kadaluwarsa:</FormLabel>
            <FormInput
              type="date"
              id="input-expired-date"
              max={toISODateInput(getInitialDate('daily'))}
              name="expiredDate"
              value={expiredDate}
              onChange={(evt) => setExpiredDate(evt.target.value)}
            />
          </div>
          <Button type="submit" variant="primary">
            <FaSearch className="mr-2" /> Cari
          </Button>
        </form>
      </div>
    </div>
  )
}
